if (!customElements.get("m-featured-collection")) {
  class MFeaturedCollection extends HTMLElement {
    constructor() {
      super();
      this.handleResponsiveChange = this.handleResponsiveChange.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.selectors = {
        loadMoreBtn: "[data-load-more]",
        loadMoreBtnWrapper: ".m-featured-collection__button",
        productsContainer: "[data-products-container]",
        products: [".m-product-card"],
        soldNumber: ["[data-sold-number]"],
        availableNumber: ["[data-available-number]"],
        countDown: "[data-flashsale-countdown]",
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.buttonType = this.dataset.buttonType;
      this.infiniteLoad = this.dataset.infiniteLoad;
      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.enableFlashsale = this.dataset.enableFlashsale === "true";
      this.enableCountdown = this.dataset.enableCountdown === "true";
      this.id = this.dataset.id;
      this.items = parseInt(this.dataset.items, 10) || 4;
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 1.2;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.initByScreenSize();
      document.addEventListener("matchMobile", this.handleResponsiveChange);
      document.addEventListener("unmatchMobile", this.handleResponsiveChange);

      if (this.enableFlashsale) this.initFlashSale();

      this.canLoad = true;
      this.currentPage = 1;
      this.spinner = spinner();

      if (!this.enableSlider && this.buttonType === "load" && this.infiniteLoad === "true") {
        this.initInfiniteLoad();
      }
      if (!this.enableSlider && this.buttonType === "load") {
        this.initLoadMore();
      }
      if (
        MinimogTheme.config.mqlMobile &&
        this.mobileDisableSlider &&
        this.buttonType === "load" &&
        this.infiniteLoad === "true"
      ) {
        this.initInfiniteLoad();
      }
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider && this.buttonType === "load") {
        this.initLoadMore();
      }

    }

    disconnectedCallback() {
      document.removeEventListener("matchMobile", this.handleResponsiveChange);
      document.removeEventListener("unmatchMobile", this.handleResponsiveChange);
      if (this.handleInfiniteScroll) window.removeEventListener("scroll", this.handleInfiniteScroll);
      clearTimeout(this.sliderInitTimeout);
      if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(false, true);
    }

    handleResponsiveChange() {
      this.initByScreenSize();
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider && this.buttonType === "load") {
        this.initLoadMore();
        if (this.infiniteLoad === "true") this.initInfiniteLoad();
      }
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainers = this.querySelectorAll(
        ".m-featured-collection__product-nav-controls, .m-featured-collection__product-controls"
      );

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        controlsContainers.forEach((controls) => controls.classList.add("m:hidden"));
        slideContainer && slideContainer.classList.remove("swiper-container");
        if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(false, true);
        this.swiper = null;
      } else {
        controlsContainers.forEach((controls) => controls.classList.remove("m:hidden"));
        clearTimeout(this.sliderInitTimeout);
        this.sliderInitTimeout = setTimeout(() => this.initSlider());
      }
    }

    toggleControls(controls, swiper) {
      if (!controls) return;
      controls.classList.toggle("m-featured-collection__controls--hidden", swiper.isLocked);
    }

    toggleProductControls(swiper) {
      this.querySelectorAll(
        ".m-featured-collection__product-nav-controls, .m-featured-collection__product-controls"
      ).forEach((controls) => this.toggleControls(controls, swiper));
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const navigationControls =
        this.querySelector(".m-featured-collection__product-nav-controls") ||
        this.querySelector(".m-featured-collection__product-controls");
      const paginationControls = this.querySelector(".m-featured-collection__product-controls");
      const prevButton = navigationControls && navigationControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = navigationControls && navigationControls.querySelector(".m-slider-controls__button-next");
      const pagination = paginationControls && paginationControls.querySelector(".swiper-pagination");
      if (!slideContainer) return;

      if (slideContainer.swiper && !slideContainer.swiper.destroyed) {
        slideContainer.swiper.update();
        this.toggleProductControls(slideContainer.swiper);
        return;
      }

      slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: this.mobileItems,
        spaceBetween: 0,
        watchOverflow: true,
        loop: false,
        pagination: this.showPagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        navigation:
          this.showNavigation && prevButton && nextButton
            ? {
                prevEl: prevButton,
                nextEl: nextButton,
              }
            : false,
        breakpoints: {
          768: {
            slidesPerView: this.items >= 3 ? 3 : this.items,
          },
          1024: {
            slidesPerView: this.items >= 4 ? 4 : this.items,
          },
          1280: {
            slidesPerView: this.items,
          },
        },
        threshold: 2,
        on: {
          init: (swiper) => this.toggleProductControls(swiper),
          breakpoint: (swiper) => this.toggleProductControls(swiper),
          resize: (swiper) => this.toggleProductControls(swiper),
        },
      });

      this.swiper = slideContainer.swiper;
    }

    initLoadMore() {
      if (this.loadMoreInitialized) return;
      this.loadMoreInitialized = true;
      this.triggerLoad = false;
      this.totalPages = parseInt(this.dataset.totalPages);

      addEventDelegate({
        context: this.container,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore();
        },
      });
    }

    initInfiniteLoad() {
      if (this.infiniteLoadInitialized) return;
      this.infiniteLoadInitialized = true;
      const maxPages = this.dataset.maxPages;

      this.handleInfiniteScroll = () => {
        this.canLoad = this.currentPage < parseInt(maxPages);

        if (!this.canLoad) return;
        if (this.offsetTop + this.clientHeight - window.innerHeight < window.scrollY && !this.triggerLoad) {
          this.triggerLoad = true;
          this.handleLoadMore();
        }
      };
      window.addEventListener("scroll", this.handleInfiniteScroll);
    }

    async handleLoadMore() {
      this.currentPage++;
      this.canLoad = this.currentPage < this.totalPages;
      this.toggleLoading(true);
      const collectionID = this.dataset.collectionId;
      const res = await fetchCountDown(collectionID);

      const url = this.dataset.url;
      const dataUrl = `${url}?page=${this.currentPage}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        this.toggleLoading(false);
        const dom = generateDomFromString(html);
        const products = dom.querySelector(this.selectors.productsContainer);
        const oldCards = this.domNodes.productsContainer.childElementCount;
        let isAppended = false;

        if (products) {
          Array.from(products.childNodes).forEach((product) => {
            this.domNodes.productsContainer.appendChild(product);
            const check = setInterval(() => {
              if (this.domNodes.productsContainer.childElementCount > oldCards) {
                clearInterval(check);
                isAppended = true;
              }
            }, 50);
          });
        }

        if (this.enableFlashsale && res.ok && res.payload && res.payload.length) {
          const { expires_date, cdt_type, duration } = res.payload[0];
          Object.assign(this, { expires_date, cdt_type, duration });
          const check = setInterval(() => {
            if (isAppended) {
              clearInterval(check);
              const cards = this.domNodes.productsContainer.querySelectorAll(".m-product-card");
              cards.forEach((card) => {
                const content = card.querySelector(".m-product-card__content");
                const progress = card.querySelector(".m-product-sale-progress");
                if (!progress) {
                  let soldNumber;
                  if (card.dataset.soldNumber) {
                    soldNumber = card.dataset.soldNumber;
                  }
                  const component = saleProgress(res.payload[0], card.dataset.productId, soldNumber);
                  const newComponent = generateDomFromString(component);
                  content.appendChild(newComponent);
                }
              });
            }
          }, 50);
        }

        this.triggerLoad = false;

        if (!this.canLoad) {
          this.domNodes.loadMoreBtn && this.domNodes.loadMoreBtn.classList.add("m:hidden");
        }
      });
    }

    toggleLoading(status) {
      if (!this.domNodes.loadMoreBtn) return;
      if (status) {
        this.domNodes.loadMoreBtn.classList.add("m-spinner-loading");
      } else {
        this.domNodes.loadMoreBtn.classList.remove("m-spinner-loading");
      }
    }

    async initFlashSale() {
      const collectionID = this.dataset.collectionId;
      const res = await fetchCountDown(collectionID);
      if (res.ok && res.payload && res.payload.length) {
        const { expires_date, cdt_type, duration } = res.payload[0];
        Object.assign(this, { expires_date, cdt_type, duration });
        this.domNodes.products.forEach((card) => {
          const content = card.querySelector(".m-product-card__content");
          const pcardSale = card.querySelector(".m-product-sale-progress");
          let soldNumber;
          if (card.dataset.soldNumber) {
            soldNumber = card.dataset.soldNumber;
          }
          const component = saleProgress(res.payload[0], card.dataset.productId, soldNumber);
          const newComponent = generateDomFromString(component);
          if (!pcardSale) {
            content.appendChild(newComponent);
          }
        });
        this.initCountDown();
      }
    }

    initCountDown() {
      const endTime = new Date(this.expires_date).getTime();
      this.countDownTimer = new CountdownTimer(this.domNodes.countDown, Date.now(), endTime, {
        type: this.cdt_type,
        duration: this.duration,
      });
    }
  }

  customElements.define("m-featured-collection", MFeaturedCollection);
}
